// extracted by mini-css-extract-plugin
export default {"container":"style_container__ZuMlZ","footer":"style_footer__pYt4C","footer_logo":"style_footer_logo__g1G97","footer_text":"style_footer_text__tMGbP"};